<template lang="html">
  <div class="app">
    <div class=""><Navber></Navber></div>
    <div style="text-align: center">
        <img src="../assets/Under-construct-01.png" width="700" />
    </div>
    <div>
        <div style="width: 719px; margin: auto">
          <h5>We are adding a few features during this Covid19 downtime,
             we'll be back soon. If you need to use AutoML, please write
              to us on contact at <a href="https://getambee.com/">getambee.com</a></h5>
        </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Toasted from 'vue-toasted'
import Vue from 'vue'
import { apiCall } from '@/utils/api'
import Navber from './navbarLogin';

Vue.use(Toasted)
export default {
  name: "UnderMaintance",
  props: {
  },
  components: {
      Navber: Navber
  },
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    routeToLogin() {
      this.$router.push('/underConstruction')
    }
  }
}
</script>
<style scoped>
.impborder {
  border: 1px solid rgba(0,0,0,.125) !important;
}
.header {
  font-size: 48px;
  letter-spacing: -0.5px;
  line-height: 58px;
}
.fit-content {
  width: fit-content;
}
.subheading {
  font-size: 1rem;
    color: #a5a4a4;
}
.border-none {
  border: none; 
}
.box-shad {
    -webkit-box-shadow: 7px 7px 5px 0px rgba(50, 50, 50, 0.75);
    -moz-box-shadow: 7px 7px 5px 0px rgba(50, 50, 50, 0.75);
    box-shadow: 1px 2px 1px 1px #cfd1de;
}
.blue {
  color: blue;
}
.white{
  color: white;
}
.cursor-pointer {
    cursor: pointer;
}
.box-shadow1{
  box-shadow: 0px 7px 6px 1px #cfd1de;
}
.margin {
  margin-left: 0.1rem;
  margin-right: 0.1rem;
}

@media screen and (max-width: 34em) {
  .paddingleft {
    padding-left: 2.5rem !important; 
  }
  .paddingRight {
    padding-right: 2.5rem !important;
  }
}
</style>
